<template>
  <div class="carnival-2020-container bus-cooperate-wrapper" v-pv>
    <div class="footer-title" />
    <div class="cooperate-text">
      <p>
        爱奇艺动漫游戏嘉年华（iQIYI FUN
        CARNIVAL，简称IFC），是爱奇艺推出的二次元线下活动。活动分为城市漫展、IP主题展、动漫音乐演出三大模块。整合优质动漫游戏IP和原创动漫游戏资源，力求打造中国最具价值、最具品质的二次元线下活动。更多商务合作，请接洽：
        <a href="mailto:IFC@qiyi.com">IFC@qiyi.com</a>
      </p>
      <p>
        爱奇艺动漫拥有涵盖题材丰富的高人气优质原创IP，面向商业伙伴开放IP资源合作，不限于品牌合作授权、垂直衍生品授权、线下实景类授权、展会摊位合作等灵活的合作形式，欢迎垂询：
        <a href="mailto:yuanyue01@qiyi.com">yuanyue01@qiyi.com</a>
      </p>
    </div>
    <div class="cooperate-works">
      <div class="cooperate-item" v-for="(item, index) in cooperates" :key="index">
        <img :src="item.img" alt="作品图" />
        <div class="work">《{{ item.name }}》</div>
      </div>
    </div>
    <div class="bottom-btn-wrapper">
      <div @click="goRouterCarnivalIndex" class="common-blue-btn">返回首页</div>
      <div class="float-bg" />
    </div>
  </div>
</template>
<script>
import { MOCK_COOPERATE } from './mock-data'

export default {
  components: {},
  data() {
    return {
      cooperates: MOCK_COOPERATE,
    }
  },
  methods: {
    goRouterCarnivalIndex() {
      this.$router.push({ name: 'carnival2020' })
    },
  },
  mounted() {},
}
</script>
<style lang="less">
@import './index.less';
.bus-cooperate-wrapper {
  padding-top: 80px;
  overflow-y: hidden;
  .footer-title {
    background: transparent url('~@/assets/carnival2020/cooperate/title.png') no-repeat;
  }
  .cooperate-text {
    width: 1060px;
    height: 174px;
    margin: 45px auto 50px;
    font-size: 20px;
    font-family: HYYakuHei55W;
    color: #ffffff;
    line-height: 35px;
    p {
      margin-bottom: 10px;
    }
    a {
      color: #ceff1c;
    }
  }
  .cooperate-works {
    max-width: 1112px;
    margin: 0 auto;
    position: relative;
    z-index: 2;
  }
  .cooperate-item {
    box-sizing: border-box;
    display: inline-block;
    width: 245px;
    height: 313px;
    overflow: hidden;
    background: #ceff1c;
    border: 4px solid #ceff1c;
    box-shadow: 15px 15px #000000;
    margin-bottom: 40px;
    margin-right: 33px;
    font-size: 0;
    img {
      width: 100%;
      height: 260px;
    }
    .work {
      width: 100%;
      padding: 10px 0 12px;
      text-align: center;
      color: #000000;
      font-size: 20px;
      box-sizing: border-box;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .bottom-btn-wrapper {
    position: relative;
    box-sizing: border-box;
    text-align: center;
    height: 245px;
    padding-top: 52px;
    .common-blue-btn {
      width: 618px;
      height: 95px;
      line-height: 90px;
      font-weight: 750;
      font-size: 36px;
      position: relative;
      z-index: 2;
    }
    .float-bg {
      left: -20px;
      bottom: 40px;
      width: 563px;
      height: 304px;
      transform: rotate(150deg);
    }
  }
}
</style>
